export const MessageDisplayOption = {
  CUSTOM_TIME: 'custom-time',
  ALWAYS: 'always',
}

export const ALWAYS_DISPLAY_MESSAGE = -1
